/**
 * UGC Tile Wall — "Worn by thousands of mums"
 * Dense grid, infinite scroll, tap opens modal.
 */
(function() {
  'use strict';

  var container = document.getElementById('ugc-wall');
  if (!container) return;

  var tenantId = container.getAttribute('data-tenant') || '';
  var storeDomain = tenantId + '.myshopishop.com';
  var cdnBase = 'https://' + storeDomain;

  function resolveUrl(url) {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    return cdnBase + (url.startsWith('/') ? '' : '/') + url;
  }

  var grid = document.getElementById('ugc-wall-grid');
  if (!grid) return;

  var cursor = 0;
  var batchSize = 30;
  var totalAvailable = Infinity;
  var loading = false;
  var allItems = [];

  function loadBatch() {
    if (loading || cursor >= totalAvailable) return;
    loading = true;

    var url = 'https://' + storeDomain + '/api/ugc-gallery?tenantId=' +
      encodeURIComponent(tenantId) + '&pdp=true&limit=' + batchSize + '&cursor=' + cursor;

    fetch(url)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!data.ok) return;
        totalAvailable = data.total || 0;
        var items = data.items || [];
        if (items.length === 0) { totalAvailable = cursor; return; }

        cursor += items.length;
        allItems = allItems.concat(items);
        renderItems(items);
        container.style.display = 'block';
      })
      .catch(function() {})
      .finally(function() { loading = false; });
  }

  function renderItems(items) {
    items.forEach(function(item) {
      var tile = document.createElement('div');
      tile.style.cssText = 'position:relative;aspect-ratio:1/1;overflow:hidden;background:#111;cursor:pointer;';

      var isVideo = item.type === 'reel' || item.type === 'video';
      var src = resolveUrl(item.posterUrl || item.url);

      tile.innerHTML = '<img src="' + src + '" alt="" loading="lazy" decoding="async" style="width:100%;height:100%;object-fit:cover;">';

      if (isVideo) {
        tile.innerHTML += '<div style="position:absolute;top:4px;right:4px;width:20px;height:20px;background:rgba(0,0,0,0.4);border-radius:50%;display:flex;align-items:center;justify-content:center;">' +
          '<div style="width:0;height:0;border-left:7px solid white;border-top:5px solid transparent;border-bottom:5px solid transparent;margin-left:2px;"></div></div>';
      }

      tile.addEventListener('click', function() {
        if (typeof window.openUgcModal !== 'function') return;
        var idx = 0;
        for (var j = 0; j < allItems.length; j++) {
          if (allItems[j].id === item.id) { idx = j; break; }
        }
        window.openUgcModal(allItems, idx);
      });

      grid.appendChild(tile);
    });
  }

  // Scroll-based infinite load (more reliable than IntersectionObserver for hidden containers)
  var sentinel = document.getElementById('ugc-wall-sentinel');
  function checkScroll() {
    if (!sentinel || loading || cursor >= totalAvailable) return;
    var rect = sentinel.getBoundingClientRect();
    if (rect.top < window.innerHeight + 600) loadBatch();
  }

  var scrollTimer = null;
  window.addEventListener('scroll', function() {
    if (scrollTimer) return;
    scrollTimer = setTimeout(function() {
      scrollTimer = null;
      checkScroll();
    }, 150);
  }, { passive: true });

  // Initial load
  loadBatch();
})();
